import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-delegate-invitation-sent',
    templateUrl: './delegate-invitation-sent.component.html',
    styleUrls: ['./delegate-invitation-sent.component.scss'],
    standalone: false
})
export class DelegateInvitationSentComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
